import { Utils } from '@genial/utils';

export const messageError = '―';

export const validateAndFormatValue = (
  value: number | Date | null,
  type: 'date' | 'money' | 'percentage'
) => {
  if (type === 'money') {
    return value || value === 0 ? Utils.Mask.Money(value as unknown as number) : messageError;
  }

  if (type === 'percentage') {
    return value || value === 0 ? Utils.Mask.Percentage(value as unknown as number) : messageError;
  }

  if (type === 'date') {
    return value ? Utils.Mask.DateFormat(value as unknown as Date, 'dd/MM/yyyy') : messageError;
  }

  return 'Erro: tipo invalido';
};
